import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-205eb499"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "データ取得日時", -1))
const _hoisted_3 = { class: "grid-item-head" }
const _hoisted_4 = { class: "grid-item-head-index" }
const _hoisted_5 = { class: "grid-item-head-title" }
const _hoisted_6 = {
  key: 1,
  class: "update-time"
}
const _hoisted_7 = { class: "update-time-inner" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "更新時刻", -1))
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "field-name" }
const _hoisted_11 = { class: "value" }
const _hoisted_12 = { class: "unit" }

import { PropType, computed } from 'vue'
import { useRouter } from 'vue-router'
import { camelCase } from 'lodash'
import { DefinitionInfoSummaryItemCommon } from '@/models/initData/DefinitionInfo'
import { usePresentStore } from '@/stores/presentStore'
import { useInitDataStore } from '@/stores/initDataStore'
import { useGlobalStore } from '@/stores/globalStore'


export default /*#__PURE__*/_defineComponent({
  props: {
  cell: {
    type: Object as PropType<DefinitionInfoSummaryItemCommon>,
    required: true,
  },
  isTop: {
    type: Boolean,
    required: false,
  },
},
  setup(__props) {

const props = __props

const FIELD_NAME_SHOTEN_DICT = {
  '10分移動積算雨量': '10分雨量',
  '1時間移動積算': '時間雨量',
}

const presentStore = usePresentStore()
const initDataStore = useInitDataStore()
const globalStore = useGlobalStore()
const router = useRouter()

const stationName = (stationId: string) => {
  const station = initDataStore.initData.stations.findById(stationId)

  return station?.name || ''
}

const cell = computed(() => props.cell)

const isCommonType2 = computed(() => {
  return camelCase(cell.value.panelType) === 'commonType2'
})

const elementStyle = (elements: string[]) => {
  const height = 100 / elements.length

  return {
    height: `${height}%`,
  }
}

const fieldName = (element: string) => {
  const name = initDataStore.fieldListItem(camelCase(element))?.name

  return FIELD_NAME_SHOTEN_DICT[name as keyof typeof FIELD_NAME_SHOTEN_DICT] || name
}

const elementIconStyle = (elementId: string) => {
  const iconName =
    elementId === 'move_rain_min_10'
      ? 'icon_rain_10'
      : elementId === 'move_rain_min_60'
      ? 'icon_rain_60'
      : elementId === 'rain_rui'
      ? 'icon_rain_rui'
      : 'icon_water'
  const imageUrl = `/images/icon/${iconName}.svg`

  return {
    'background-image': `url('${imageUrl}')`,
  }
}

const renderValue = (value?: number, decimal?: number) => {
  if (value === undefined || value === null) {
    return '-'
  }

  return value.toFixed(decimal)
}

const handleClickElement = (cell: DefinitionInfoSummaryItemCommon, element: { id: string; type: string }) => {
  if (globalStore.isSP) {
    return
  }

  const isWater = element.type === 'water'

  const path = isWater ? `/water_detail/${cell.args.stationId}` : `/rain_detail/${cell.args.stationId}`

  router.push(path)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!props.isTop)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          id: `popup-${_unref(cell).args.no}`,
          class: "popup"
        }, [
          _hoisted_2,
          _createElementVNode("p", null, _toDisplayString(_unref(presentStore).getTime(_unref(cell).args.stationId)), 1)
        ], 8, _hoisted_1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(cell).args.no), 1),
      _createElementVNode("span", _hoisted_5, _toDisplayString(stationName(_unref(cell).args.stationId)), 1)
    ]),
    (_unref(isCommonType2))
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("p", null, _toDisplayString(_unref(presentStore).getTime(_unref(cell).args.stationId, 'HH:mm')), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass([`elements-${_unref(cell).args.element.length} ${props.isTop && 'grid-item-body-top'} ${_unref(cell).panelType}`, "grid-item-body"])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cell).args.element, (element, index) => {
        return (_openBlock(), _createElementBlock("div", {
          onClick: ($event: any) => (handleClickElement(_unref(cell), element)),
          key: index,
          style: _normalizeStyle(elementStyle(Object.keys(_unref(cell).args.element))),
          class: "gird-item-body-element"
        }, [
          _createElementVNode("span", {
            style: _normalizeStyle(elementIconStyle(element.id)),
            class: "icon"
          }, null, 4),
          _createElementVNode("span", _hoisted_10, _toDisplayString(fieldName(element.id)), 1),
          _createElementVNode("div", _hoisted_11, _toDisplayString(renderValue(
            _unref(presentStore).getValue(_unref(cell).args.stationId, element.id) as number,
            _unref(initDataStore).getDecimal(element.id) as number
          )), 1),
          _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(initDataStore).getUnit(element.id)), 1)
        ], 12, _hoisted_9))
      }), 128))
    ], 2)
  ], 64))
}
}

})